import { getItem, removeItem, setItem } from '@/lib';

const TOKEN = 'token';

export type TokenType = {
  token: string;
};

export const getToken = () => getItem<TokenType>(TOKEN);
export const removeToken = () => removeItem(TOKEN);
export const setToken = (value: TokenType) => setItem<TokenType>(TOKEN, value);
